import React, { useState } from "react";
import Sidebar from "@/components/shell/Sidebar";
import Topbar from "@/components/shell/Topbar";

export default function Layout({ children, currentPageName }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar currentPageName={currentPageName} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className="lg:pl-72 flex flex-col min-h-screen">
        <Topbar currentPageName={currentPageName} onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1">
          <div key={currentPageName} className="animate-fade-in">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
